import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  AiOutlinePlus,
  AiOutlineMinus,
  AiOutlineCheck,
  AiOutlineClose,
} from 'react-icons/ai';
import { BsFillQuestionCircleFill } from 'react-icons/bs';

import * as Yup from 'yup';
import { format } from 'date-fns';
import { Form } from '@unform/web';
import { BiLoaderAlt } from 'react-icons/bi';

import omitEmpty from 'omit-empty';
import ApiClient from '~/utils/ApiClient';

import {
  Input,
  Select,
  ChoiceButtonLocacao,
  Textarea,
  File,
  FormChoiceButton,
  InputNoForm,
} from '~/components/Forms';

import {
  PageContainer,
  ConditionalContainer,
  LimiterInputWidth,
  MultiInputContainer,
  ActionInputMulti,
  ContainerMultiInputActions,
  TooltipContainer,
} from '~/styles/components';

import { NavBarHeader, ModalPorteFilmagem } from '~/components/Usuario';

import {
  BannerContent,
  TextBanner,
  PageContent,
  PageFooter,
  BoxHeader,
} from '~/pages/Usuario/styles';

import ImpactoListActions from '~/store/ducks/impacto-list';
import EquipamentoFilmagemListActions from '~/store/ducks/equipamento-filmagem-list';
import SomFilmagemListActions from '~/store/ducks/som-filmagem-list';
import EfeitoEspecialListActions from '~/store/ducks/efeito-especial-list';
import FinalidadeBaseApoioListActions from '~/store/ducks/finalidade-base-apoio-list';
import LdEquipamentosSmcListActions from '~/store/ducks/ld-equipamentos-smc';
import LdBibliotecaListActions from '~/store/ducks/ld-biblioteca';
import LdMuseuListActions from '~/store/ducks/ld-museu';
import LdCasasCulturaListActions from '~/store/ducks/ld-casas-cultura';
import LdCentroCulturalListActions from '~/store/ducks/ld-centro-cultural';

import { Wrap, MainLoading } from './styles';
import Button from '~/components/Button';
import { showModalMessage } from '~/services/notification';
import Chat from '~/components/Chat/chat';
import { useList } from '~/hooks/useFunction';
import diffDatasFilmagem from '~/utils/functions/diffDatasFilmagem';
import diffHoursFilmagem from '~/utils/functions/diffHoursFilmagem';
import LogoIcon from '~/components/LogoIcon';
import {
  confirmEditDateHour,
  getBrowserTransformDate,
  validDateArray,
  validHourArray,
} from '~/pages/Usuario/Locacoes/functions/date-hour-utils';
import Header from '~/components/Header';
import BannerHeader from '~/components/BannerHeader';
import WhiteBox from '~/components/WhiteBox';
import clientResources from '~/data/clientResources';
import { DateFormMultiInput } from '~/components/Forms/DateFormMultiInput';
import { HourFormMultiInput } from '~/components/Forms/HourFormMultiInput';

export const selectCustomStyles = {
  option: provided => ({
    ...provided,
    borderBottom: `1px #ddd solid`,
    color: '#828282',
    backgroundColor: '#f2f2f2',
    padding: 16,
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
  }),
  input: provided => ({
    ...provided,
    padding: 16,
    fontSize: 14,
    margin: 0,
  }),
  container: provided => ({
    ...provided,
    padding: 0,
    marginBottom: 15,
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
  }),
  placeholder: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    padding: 0,
    fontFamily: 'PoppinsSemiBold',
  }),
  control: provided => ({
    ...provided,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d0d0d0',
    borderRadius: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f2f2f2',
    boxShadow: '0 3px 12px rgba(0, 0, 0, 0.075)',
    height: 48,
    outline: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    color: '#828282',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    fontSize: 10,
    color: '#828282',
  }),
};

const itensLocalFilmagemChoice = [
  'Arquivo Histórico Municipal',
  'Biblioteca Mário Andrade',
  'Casas de Cultura',
  'Central de Serviços do Pari',
  'Centro de Referência da Dança',
  'Centros Culturais',
  'Bibliotecas',
];

const EspacosDeCulturaEdit = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const dadoState = location.state;
  const isAdminRequest = dadoState?.isAdminRequest || false;

  // refs
  const formRef = useRef();
  const relatorioArteRef = useRef(null);

  // states
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [responseLocation, setResponseLocation] = useState();
  const [openModalPorteFilmagem, setOpenModalPorteFilmagem] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});

  // state choices
  const [localFilmagem, setLocalFilmagem] = useState(null);
  const [isolarLocal, setIsolarLocal] = useState(null);
  const [intervencaoArte, setIntervencaoArte] = useState(null);
  const [gerador, setGerador] = useState(null);
  const [blimpado, setBlimpado] = useState(null);
  const [geradorPortatil, setGeradorPortatil] = useState(null);
  const [baseLocal, setBaseLocal] = useState(null);
  const [captacaoSomDireto, setCaptacaoSomDireto] = useState(null);
  const [somFilmagem, setSomFilmagem] = useState(null);
  const [efeitosEspeciais, setEfeitosEspeciais] = useState(null);
  const [haveraAnimais, setHaveraAnimais] = useState(null);
  const [reservasVagas, setReservasVagas] = useState(null);

  // state files
  const [relatorioArteFile, setRelatorioArteFile] = useState(null);
  const [dataRelatorioArteFile, setDataRelatorioArteFile] = useState(null);

  // state outro fields
  const [showOutroEspacosField, setShowOutroEspacosField] = useState(false);
  const [showOutroEquipamentoField, setShowOutroEquipamentoField] =
    useState(false);
  const [showOutroFinalidadeField, setShowOutroFinalidadeField] =
    useState(false);
  const [showOutroSomFilmagemField, setShowOutroSomFilmagemField] =
    useState(false);

  // state show fields
  const [showDescrAltoImpactoLocalField, setShowDescrAltoImpactoLocalField] =
    useState(false);
  const [
    showDescrEquipamentoFilmagemField,
    setShowDescrEquipamentoFilmagemField,
  ] = useState(false);
  const [showDescrSomFilmagemField, setShowDescrSomFilmagemField] =
    useState(false);
  const [showSelectLdEspacos, setShowSelectLdEspacos] = useState(false);

  // states multi input
  const [horasFilmagemInputs, setHorasFilmagemInputs] = useState([
    { inicio: '', fim: '' },
  ]);
  const [datasFilmagemInputs, setDatasFilmagemInputs] = useState([
    { data_filmagem: '' },
  ]);

  // selectors
  const { data: impactoSelectList } = useSelector(state => state.impactoList);
  const { data: equipamentosSelectList } = useSelector(
    state => state.equipamentoFilmagemList,
  );
  const { data: finalidadeSelectList } = useSelector(
    state => state.finalidadeBaseApoioList,
  );
  const { data: somFilmagemSelectList } = useSelector(
    state => state.somFilmagemList,
  );
  const { data: efeitoEspecialSelectList } = useSelector(
    state => state.efeitoEspecialList,
  );
  const { data: ldEquipamentosSmcList } = useSelector(
    state => state.ldEquimentosSmcList,
  );
  const { data: ldBibliotecaList } = useSelector(
    state => state.ldBibliotecaList,
  );
  const { data: ldMuseuList } = useSelector(state => state.ldMuseuList);
  const { data: ldCentroCulturalList } = useSelector(
    state => state.ldCentroCulturalList,
  );
  const { data: ldCasasCulturaList } = useSelector(
    state => state.ldCasasCulturaList,
  );

  // effects
  useEffect(() => {
    dispatch(ImpactoListActions.showRequest());
    dispatch(EquipamentoFilmagemListActions.showRequest());
    dispatch(SomFilmagemListActions.showRequest());
    dispatch(EfeitoEspecialListActions.showRequest());
    dispatch(FinalidadeBaseApoioListActions.showRequest());
    dispatch(LdEquipamentosSmcListActions.showRequest());
    dispatch(LdBibliotecaListActions.showRequest());
    dispatch(LdMuseuListActions.showRequest());
    dispatch(LdCasasCulturaListActions.showRequest());
    dispatch(LdCentroCulturalListActions.showRequest());
  }, [dispatch]);

  const ldEspacosEquipamentosList = useList({
    url: `ld-espacos-equipamentos/equipamento/${formData?.ld_equipamentos_smc?.value}?paginate=false`,
  }).map(iee => ({ value: iee.uuid, label: iee.name }));

  // Busca dados da locação
  const visualizacaoDadosCB = useCallback(async () => {
    if (dadoState?.viewData) {
      setLoading(true);
      const resp = await ApiClient.doRequest({
        uri: `locacao-espacos-cultura/${dadoState?.viewData?.uuid}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      const respLoc = resp?.data?.data;

      // set temp variables
      const localFilmagemTmp = itensLocalFilmagemChoice.includes(
        respLoc?.ld_equipamentos_smc?.name,
      );
      const blimpadoTmp =
        respLoc?.locacao_default.blimpado === null
          ? null
          : respLoc?.locacao_default.blimpado === 1;

      const geradorPortatilTmp =
        respLoc?.locacao_default.gerador_portatil === null
          ? null
          : respLoc?.locacao_default.gerador_portatil === 1;

      const fileArte = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Relatório de Arte',
      );

      // set campos 'multi'
      setDatasFilmagemInputs(
        respLoc?.locacao_default?.dates_locacao_default?.map(
          ({ uuid, date, changes_to_approve }) => {
            return omitEmpty({
              uuid,
              data_filmagem: getBrowserTransformDate(date.split(' ')[0], true),
              changes_to_approve,
              show_confirm_btns: changes_to_approve !== undefined,
            });
          },
        ),
      );

      setHorasFilmagemInputs(
        respLoc?.locacao_default?.hours_locacao_default?.map(
          ({ uuid, inicio, fim, changes_to_approve }) => {
            return omitEmpty({
              uuid,
              inicio: inicio.substring(0, 5),
              fim: fim.substring(0, 5),
              changes_to_approve,
              show_confirm_btns: changes_to_approve !== undefined,
            });
          },
        ),
      );

      // set choices buttons
      setLocalFilmagem(localFilmagemTmp);
      setIsolarLocal(typeof respLoc?.locacao_default.fluxo_area === 'string');

      setIntervencaoArte(
        typeof respLoc?.locacao_default.desc_intervencao_arte === 'string' ||
          fileArte?.length > 0,
      );
      setBlimpado(blimpadoTmp);
      setGeradorPortatil(geradorPortatilTmp);
      setGerador(blimpadoTmp !== null || geradorPortatilTmp !== null);

      setBaseLocal(
        Object.values(respLoc?.locacao_default.ld_finalidade_base_apoio || [])
          .length > 0 ||
          typeof respLoc?.locacao_default.local_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.dimensao_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.quantidade_barracas === 'string',
      );
      setCaptacaoSomDireto(respLoc?.locacao_default?.captação_som_direto === 1);
      setSomFilmagem(
        Object.values(respLoc?.locacao_default.ld_som_filmagem || []).length >
          0,
      );
      setEfeitosEspeciais(
        Object.values(respLoc?.locacao_default.ld_efeitos_especiais || {})
          .length > 0,
      );
      setHaveraAnimais(
        typeof respLoc?.locacao_default.animais_em_cena === 'string',
      );

      setReservasVagas(
        Object.values(respLoc?.locacao_via_externa || []).length > 0,
      );

      // set campos 'Outro'
      setShowDescrAltoImpactoLocalField(
        typeof respLoc?.locacao_default?.descr_alto_impacto_local === 'string',
      );
      setShowOutroEspacosField(typeof respLoc?.outros_espacos === 'string');
      setShowOutroSomFilmagemField(
        typeof respLoc?.locacao_default?.outro_som_filmagem === 'string',
      );
      setShowOutroFinalidadeField(
        typeof respLoc?.locacao_default?.outro_finalidade === 'string',
      );
      setShowOutroEquipamentoField(
        typeof respLoc?.locacao_default?.outro_equipamento === 'string',
      );

      // set select default values
      formRef.current?.setFieldValue('ld_impacto_uuid', {
        label: respLoc?.locacao_default?.ld_impacto?.name,
        value: respLoc?.locacao_default?.ld_impacto?.uuid,
      });

      formRef.current?.setFieldValue('ld_equipamentos_smc', {
        label: respLoc?.ld_equipamentos_smc?.name,
        value: respLoc?.ld_equipamentos_smc?.uuid,
      });

      formRef.current?.setFieldValue('ld_equipamento_museu_cidade_sp_uuid', {
        label: respLoc?.ld_museu?.name,
        value: respLoc?.ld_museu?.uuid,
      });

      formRef.current?.setFieldValue('ld_equipamento_biblioteca_uuid', {
        label: respLoc?.ld_bibliotecas?.name,
        value: respLoc?.ld_bibliotecas?.uuid,
      });

      formRef.current?.setFieldValue('ld_equipamento_central_cultura_uuid', {
        label: respLoc?.ld_centros_culturais?.name,
        value: respLoc?.ld_centros_culturais?.uuid,
      });

      formRef.current?.setFieldValue('ld_equipamento_casa_cultura_uuid', {
        label: respLoc?.ld_casas_cultura?.name,
        value: respLoc?.ld_casas_cultura?.uuid,
      });

      formRef.current?.setFieldValue(
        'ld_espacos',
        respLoc?.ld_espacos?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue('outros_espacos', respLoc?.outros_espacos);

      formRef.current?.setFieldValue(
        'ld_equipamento_filmagem',
        respLoc?.locacao_default?.ld_equipamento_filmagem.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_finalidade_base_apoio',
        respLoc?.locacao_default?.ld_finalidade_base_apoio?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_som_filmagem',
        respLoc?.locacao_default?.ld_som_filmagem?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue('ld_efeitos_especiais_uuid', {
        label: respLoc?.locacao_default?.ld_efeitos_especiais?.name,
        value: respLoc?.locacao_default?.ld_efeitos_especiais?.uuid,
      });

      setResponseLocation(resp?.data?.data);
      setLoading(false);
    }
  }, [dadoState]);

  useEffect(() => {
    visualizacaoDadosCB();
  }, [visualizacaoDadosCB]);

  // handles true/false
  function handleLocalFilmagemTrue(e) {
    e.preventDefault();
    setLocalFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handleLocalFilmagemFalse(e) {
    e.preventDefault();
    setLocalFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handleIsolarLocalTrue(e) {
    e.preventDefault();
    setIsolarLocal(true);
    setErrorsForm(state => ({
      ...state,
      isolarLocal: false,
    }));
  }

  function handleIsolarLocalFalse(e) {
    e.preventDefault();
    setIsolarLocal(false);
    setErrorsForm(state => ({
      ...state,
      isolarLocal: false,
    }));
  }

  function handleIntervencaoArteTrue(e) {
    e.preventDefault();
    setIntervencaoArte(true);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleIntervencaoArteFalse(e) {
    e.preventDefault();
    setIntervencaoArte(false);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleGeradorTrue(e) {
    e.preventDefault();
    setGerador(true);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleGeradorFalse(e) {
    e.preventDefault();
    setGerador(false);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleGeradorPortatilTrue(e) {
    e.preventDefault();
    setGeradorPortatil(true);
    setErrorsForm(state => ({
      ...state,
      geradorPortatil: false,
    }));
  }

  function handleGeradorPortatilFalse(e) {
    e.preventDefault();
    setGeradorPortatil(false);
    setErrorsForm(state => ({
      ...state,
      geradorPortatil: false,
    }));
  }

  function handleBlimpadorTrue(e) {
    e.preventDefault();
    setBlimpado(true);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBlimpadorFalse(e) {
    e.preventDefault();
    setBlimpado(false);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBaseLocalTrue(e) {
    e.preventDefault(e);
    setBaseLocal(true);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleBaseLocalFalse(e) {
    e.preventDefault(e);
    setBaseLocal(false);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleCaptacaoSomDiretoTrue(e) {
    e.preventDefault();
    setCaptacaoSomDireto(true);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleCaptacaoSomDiretoFalse(e) {
    e.preventDefault();
    setCaptacaoSomDireto(false);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleSomFilmagemTrue(e) {
    e.preventDefault(e);
    setSomFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleSomFilmagemFalse(e) {
    e.preventDefault(e);
    setSomFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleEfeitosEspeciaisTrue(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(true);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleEfeitosEspeciaisFalse(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(false);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleHaveraAnimaisTrue(e) {
    e.preventDefault(e);
    setHaveraAnimais(true);
    setErrorsForm(state => ({
      ...state,
      haveraAnimais: false,
    }));
  }

  function handleHaveraAnimaisFalse(e) {
    e.preventDefault(e);
    setHaveraAnimais(false);
    setErrorsForm(state => ({
      ...state,
      haveraAnimais: false,
    }));
  }

  function handleReservasVagasTrue(e) {
    e.preventDefault(e);
    setReservasVagas(true);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  function handleReservasVagasFalse(e) {
    e.preventDefault(e);
    setReservasVagas(false);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  // handles files
  function handleRelatorioArteFile() {
    return relatorioArteRef.current.click();
  }

  const convertBase64 = arquivo => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(arquivo);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  // Verification & Filter files
  let fileArte = [];
  fileArte = responseLocation?.locacao_default?.files?.filter(
    file => file.name === 'Relatório de Arte',
  );

  async function handleFileChange(event) {
    event.preventDefault();
    const { name } = event.target;

    const file = event.target.files[0];
    const base64 = await convertBase64(file);

    if (name === 'relatorio_arte_file') {
      setRelatorioArteFile(base64.split('base64,'));
      setDataRelatorioArteFile(file);
      setErrorsForm(state => ({
        ...state,
        relatorioArteFile: false,
      }));
    }

    setFormData(state => ({ ...state, [name]: base64.split('base64,')[1] }));
  }

  // handles multi select
  function handleMultiSelectEspacos(e) {
    setShowOutroEspacosField(!!e?.find(x => x.label.startsWith('Outro(s)')));

    setFormData(state => ({
      ...state,
      ld_espacos: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectEquipamentos(e) {
    setShowOutroEquipamentoField(!!e?.find(x => x.label === 'Outro'));
    setShowDescrEquipamentoFilmagemField(
      e?.some(equip => equip.label?.includes(':')) || false,
    );

    setFormData(state => ({
      ...state,
      ld_equipamento_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectFinalidades(e) {
    setShowOutroFinalidadeField(!!e?.find(x => x.label === 'outro, descreva'));

    setFormData(state => ({
      ...state,
      ld_finalidade_base_apoio: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectSomFilmagem(e) {
    setShowOutroSomFilmagemField(!!e?.find(x => x.label === 'outro'));
    setShowDescrSomFilmagemField(
      e?.some(equip => equip.label?.includes('descrever')) || false,
    );

    setFormData(state => ({
      ...state,
      ld_som_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  // handles changes
  function handleChange(event) {
    const { name, value } = event.target;
    setFormData(state => ({ ...state, [name]: value }));
  }

  function handleSelectChange(name, option) {
    const value = option ? option.value : null;
    setFormData(state => ({ ...state, [name]: value }));
  }

  function formatDefaultData(data) {
    // files uuids
    const fileArteUuid = fileArte?.length > 0 ? fileArte[0].uuid : null;

    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      ld_impacto_uuid: data?.ld_impacto_uuid,
      ld_equipamento_filmagem: data?.ld_equipamento_filmagem,
      tamanho_equipe_tecnica: data?.tamanho_equipe_tecnica,
      tamanho_do_elenco: data?.tamanho_do_elenco,
      descricao_cena: data?.descricao_cena,
      especificidades: data?.especificidades,
    });

    // dados de choices
    const dataIsolarLocal = {
      fluxo_area: localFilmagem && isolarLocal ? data?.fluxo_area : null,
    };

    const dataIntervencaoArte = intervencaoArte
      ? {
          desc_intervencao_arte: data?.desc_intervencao_arte,
          relat_arte_base64: data?.relatorio_arte_file
            ? data?.relatorio_arte_file
            : null,
          relat_arte_base64_uuid: data?.relatorio_arte_file
            ? fileArteUuid
            : null,
        }
      : {
          desc_intervencao_arte: null,
          relat_arte_base64: null,
          relat_arte_base64_uuid: fileArteUuid,
        };

    const dataGerador = gerador
      ? { blimpado, gerador_portatil: geradorPortatil }
      : { blimpado: null, gerador_portatil: null };

    const dataBaseLocal = baseLocal
      ? {
          ld_finalidade_base_apoio: data?.ld_finalidade_base_apoio,
          local_base_apoio: data?.local_base_apoio,
          dimensao_base_apoio: data?.dimensao_base_apoio,
          quantidade_barracas: data?.quantidade_barracas,
        }
      : {
          ld_finalidade_base_apoio: null,
          local_base_apoio: null,
          dimensao_base_apoio: null,
          quantidade_barracas: null,
        };

    const dataCaptacaoSomDireto = { captação_som_direto: captacaoSomDireto };

    const dataSomFilmagem = {
      ld_som_filmagem: somFilmagem ? data?.ld_som_filmagem : null,
    };

    const dataEfeitosEspeciais = {
      ld_efeitos_especiais_uuid: efeitosEspeciais
        ? data?.ld_efeitos_especiais_uuid
        : null,
    };

    const dataHaveraAnimais = {
      animais_em_cena: haveraAnimais ? data?.descricao_animais : null,
    };

    // dados de campos exibidos condicionalmente
    const dataDescrAltoImpactoLocal = {
      descr_alto_impacto_local: showDescrAltoImpactoLocalField
        ? data?.descr_alto_impacto_local
        : null,
    };

    const dataDescrEquipamentoFilmagem = {
      descricoes_equipamento_filmagem: showDescrEquipamentoFilmagemField
        ? data?.descricoes_equipamento_filmagem
        : null,
    };

    const dataDescrSomFilmagem = {
      descricoes_som_filmagem:
        somFilmagem && showDescrSomFilmagemField
          ? data?.descricoes_som_filmagem
          : null,
    };

    const dataOutroEquipamento = {
      outro_equipamento: showOutroEquipamentoField
        ? data?.outro_equipamento
        : null,
    };

    const dataOutroFinalidade = {
      outro_finalidade:
        baseLocal && showOutroFinalidadeField ? data?.outro_finalidade : null,
    };

    const dataOutroSomFilmagem = {
      outro_som_filmagem:
        somFilmagem && showOutroSomFilmagemField
          ? data?.outro_som_filmagem
          : null,
    };

    // diff dates e hours
    const diffDatas = diffDatasFilmagem({
      datasFilmagemLocacao:
        responseLocation.locacao_default.dates_locacao_default.map(
          ({ uuid, date, changes_to_approve }) =>
            omitEmpty({
              uuid,
              data_filmagem: getBrowserTransformDate(date.split(' ')[0], true),
              changes_to_approve,
            }),
        ),
      datasFilmagemInput: datasFilmagemInputs?.map(
        ({ uuid, data_filmagem, changes_to_approve }) =>
          omitEmpty({
            uuid,
            data_filmagem,
            changes_to_approve,
          }),
      ),
      dateKeyName: 'data_filmagem',
    });

    const diffHours = diffHoursFilmagem({
      hoursFilmagemLocacao:
        responseLocation?.locacao_default?.hours_locacao_default?.map(
          ({ uuid, inicio, fim, changes_to_approve }) =>
            omitEmpty({
              uuid,
              inicio: inicio.substring(0, 5),
              fim: fim.substring(0, 5),
              changes_to_approve,
            }),
        ),
      hoursFilmagemInput: horasFilmagemInputs?.map(
        ({ uuid, inicio, fim, changes_to_approve }) =>
          omitEmpty({
            uuid,
            inicio,
            fim,
            changes_to_approve,
          }),
      ),
      hourBeginKeyName: 'inicio',
      hourEndKeyName: 'fim',
    });

    return Object.assign(
      dataNaoCondicional,
      { dates: diffDatas },
      { hours: diffHours },
      dataIsolarLocal,
      dataIntervencaoArte,
      dataGerador,
      dataBaseLocal,
      dataCaptacaoSomDireto,
      dataSomFilmagem,
      dataEfeitosEspeciais,
      dataHaveraAnimais,
      dataDescrAltoImpactoLocal,
      dataDescrEquipamentoFilmagem,
      dataOutroEquipamento,
      dataOutroFinalidade,
      dataDescrSomFilmagem,
      dataOutroSomFilmagem,
    );
  }

  function formatEspecificaData(data) {
    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      titulo_locacao: data?.titulo_locacao,
      ld_equipamentos_smc_uuid: data?.ld_equipamentos_smc?.value,
      address: data?.address,
    });

    // dados de campos exibidos condicionalmente
    const dataOutrosEquipamentosSMC =
      data?.ld_equipamentos_smc?.label === 'Outros'
        ? {
            outros_equipamentos_smc: data?.outros_equipamentos_smc,
            outros_espacos_equipamentos_smc:
              data?.outros_espacos_equipamentos_smc,
          }
        : {
            outros_equipamentos_smc: null,
            outros_espacos_equipamentos_smc: null,
          };

    const dataEspacosMuseuCidadeSaoPaulo = {
      ld_equipamento_museu_cidade_sp_uuid:
        data?.ld_equipamentos_smc?.label ===
        'Espaços do Museu da cidade de São Paulo'
          ? data?.ld_equipamento_museu_cidade_sp_uuid
          : null,
    };

    const dataBibliotecas = {
      ld_equipamento_biblioteca_uuid:
        data?.ld_equipamentos_smc?.label === 'Bibliotecas'
          ? data?.ld_equipamento_biblioteca_uuid
          : null,
    };

    const dataCentrosCulturais = {
      ld_equipamento_central_cultura_uuid:
        data?.ld_equipamentos_smc?.label === 'Centros Culturais'
          ? data?.ld_equipamento_central_cultura_uuid
          : null,
    };

    const dataCasasCultura = {
      ld_equipamento_casa_cultura_uuid:
        data?.ld_equipamentos_smc?.label === 'Casas de Cultura'
          ? data?.ld_equipamento_casa_cultura_uuid
          : null,
    };

    const dataLdEspacos = {
      ld_espacos:
        (localFilmagem ||
          !itensLocalFilmagemChoice.includes(
            formData?.ld_equipamentos_smc?.label,
          )) &&
        formData?.ld_equipamentos_smc?.label !== 'Outros'
          ? data?.ld_espacos
          : null,
    };

    const dataOutrosEspacos = {
      outros_espacos:
        (localFilmagem ||
          !itensLocalFilmagemChoice.includes(
            formData?.ld_equipamentos_smc?.label,
          )) &&
        formData?.ld_equipamentos_smc?.label !== 'Outros' &&
        showOutroEspacosField
          ? data?.outros_espacos
          : null,
    };

    return Object.assign(
      dataNaoCondicional,
      dataOutrosEquipamentosSMC,
      dataEspacosMuseuCidadeSaoPaulo,
      dataBibliotecas,
      dataCentrosCulturais,
      dataCasasCultura,
      dataLdEspacos,
      dataOutrosEspacos,
    );
  }

  async function handleValidationFields(data) {
    try {
      if (!validDateArray(datasFilmagemInputs, 'data_filmagem')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas datas válidas!',
        });
        return false;
      }

      if (!validHourArray(horasFilmagemInputs, 'inicio', 'fim')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas horas válidas!',
        });
        return false;
      }
    } catch (err) {
      await showModalMessage({
        type: 'error',
        text: err.message,
      });
      return false;
    }

    return true;
  }

  async function handleSubmit(data) {
    // files
    data.relatorio_arte_file = formData?.relatorio_arte_file;

    // selects
    data.ld_equipamento_filmagem = formData?.ld_equipamento_filmagem;
    data.ld_espacos = formData?.ld_espacos;
    data.ld_som_filmagem = formData?.ld_som_filmagem;
    data.ld_finalidade_base_apoio = formData?.ld_finalidade_base_apoio;
    data.ld_equipamentos_smc = formData?.ld_equipamentos_smc;

    try {
      if (!(await handleValidationFields(data))) {
        return;
      }

      const defaultData = formatDefaultData(data);
      const especificaData = formatEspecificaData(data);

      setLoading(true);

      if (isAdminRequest) {
        await ApiClient.doRequest({
          uri: `locacao-default/${responseLocation?.locacao_default?.uuid}`,
          method: ApiClient.PATCH,
          body: defaultData,
          expectedStatus: 201,
        });

        await ApiClient.doRequest({
          uri: `locacao-espacos-cultura/${responseLocation?.uuid}`,
          method: ApiClient.PATCH,
          body: especificaData,
          expectedStatus: 201,
        });

        setLoading(false);

        await showModalMessage({
          type: 'success',
          title: 'Filmagens em Espaços de Cultura',
          text: 'Alteração enviada com sucesso',
        });

        history.push('/locacoes');
      } else {
        if (!defaultData?.dates && !defaultData?.hours) {
          setLoading(false);
          await showModalMessage({
            type: 'info',
            title: 'Filmagens em Espaços de Cultura',
            text: 'Não houve alteração em Data/Hora a ser salva',
          });
          return;
        }

        await ApiClient.doRequest({
          uri: `locacao-default/common-user/${responseLocation?.locacao_default?.uuid}`,
          method: ApiClient.PATCH,
          body: {
            dates: defaultData?.dates,
            hours: defaultData?.hours,
          },
          expectedStatus: 201,
        });

        setLoading(false);

        await showModalMessage({
          type: 'success',
          title: 'Filmagens em Espaços de Cultura',
          text: 'As alterações foram enviadas para avaliação da Ilhacine',
        });

        history.push('/home-user');
      }
    } catch (err) {
      setLoading(false);
      await showModalMessage({
        type: 'error',
        title: 'Filmagens em Espaços de Cultura',
        text: err.message,
      });
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  function renderLocacao() {
    if (dadoState?.viewData && !loading && !responseLocation) {
      return (
        <PageContainer style={{ height: '100%' }}>
          <PageContent>
            <WhiteBox column jCenter aCenter marginBottom="30px">
              <h3 style={{ color: '#828282' }}>Nenhuma Locação encontrada</h3>
            </WhiteBox>
          </PageContent>
        </PageContainer>
      );
    }

    return (
      <>
        {loading && (
          <MainLoading loading={loading}>
            <h3>Processando Informações</h3>
            <BiLoaderAlt size={32} color="#ffffff" className="icon-spin" />
          </MainLoading>
        )}
        <PageContainer>
          <PageContent>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <WhiteBox column jCenter aCenter marginBottom="30px">
                {responseLocation?.protocol && (
                  <BoxHeader>
                    <span
                      className="boxText"
                      style={{ color: '#828282' }}
                    >{`[ Número: ${responseLocation?.protocol} ]`}</span>
                  </BoxHeader>
                )}

                <Wrap>
                  <LimiterInputWidth w50>
                    <Input
                      type="text"
                      name="titulo_locacao"
                      label="Nome da Locação (Opcional)"
                      onChange={handleChange}
                      defaultValue={
                        dadoState?.viewData && responseLocation?.titulo_locacao
                      }
                      disabled={!isAdminRequest}
                      questionTooltip="Para controle interno das produções, é possível adicionar o nome da locação, como por exemplo: Casa da Personagem Principal. Esse controle não constará em pedidos e documentações oficiais, e é somente um facilitador em projetos de grande porte."
                    />
                  </LimiterInputWidth>
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_impacto_uuid"
                      label="Você classifica sua filmagem como sendo:"
                      placeholder="Selecione"
                      required
                      questionTooltip="Clique aqui para saber mais"
                      questionOnClick={() => setOpenModalPorteFilmagem(true)}
                      options={impactoSelectList}
                      style={selectCustomStyles}
                      onChange={value => {
                        handleSelectChange('ld_impacto_uuid', value);
                        setShowDescrAltoImpactoLocalField(
                          value.label === 'alto impacto no local',
                        );
                      }}
                      isDisabled={!isAdminRequest}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer
                  show={
                    formData?.ld_equipamentos_smc?.label ===
                    'Espaços do Museu da cidade de São Paulo'
                  }
                >
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_equipamento_museu_cidade_sp_uuid"
                        label="Equipamentos"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        required
                        options={ldMuseuList}
                        onChange={value => {
                          handleSelectChange(
                            'ld_equipamento_museu_cidade_sp_uuid',
                            value,
                          );
                        }}
                        isDisabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <ConditionalContainer
                  show={formData?.ld_equipamentos_smc?.label === 'Bibliotecas'}
                >
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_equipamento_biblioteca_uuid"
                        label="Equipamentos"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        required
                        options={ldBibliotecaList}
                        onChange={value => {
                          handleSelectChange(
                            'ld_equipamento_biblioteca_uuid',
                            value,
                          );
                        }}
                        isDisabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <ConditionalContainer
                  show={
                    formData?.ld_equipamentos_smc?.label === 'Centros Culturais'
                  }
                >
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_equipamento_central_cultura_uuid"
                      label="Equipamentos"
                      placeholder="Selecione"
                      style={selectCustomStyles}
                      required
                      options={ldCentroCulturalList}
                      onChange={value => {
                        handleSelectChange(
                          'ld_equipamento_central_cultura_uuid',
                          value,
                        );
                      }}
                      isDisabled={!isAdminRequest}
                    />
                  </LimiterInputWidth>
                </ConditionalContainer>

                <ConditionalContainer
                  show={
                    formData?.ld_equipamentos_smc?.label === 'Casas de Cultura'
                  }
                >
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_equipamento_casa_cultura_uuid"
                      label="Equipamentos"
                      placeholder="Selecione"
                      style={selectCustomStyles}
                      required
                      options={ldCasasCulturaList}
                      onChange={value => {
                        handleSelectChange(
                          'ld_equipamento_casa_cultura_uuid',
                          value,
                        );
                      }}
                      isDisabled={!isAdminRequest}
                    />
                  </LimiterInputWidth>
                </ConditionalContainer>

                <ConditionalContainer
                  show={itensLocalFilmagemChoice.includes(
                    formData?.ld_equipamentos_smc?.label,
                  )}
                >
                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Já possui local definido para filmagem?"
                        onClickTrue={handleLocalFilmagemTrue}
                        onClickFalse={handleLocalFilmagemFalse}
                        selected={localFilmagem}
                        required
                        isDisabled={!isAdminRequest}
                        error={
                          errorsForm.localFilmagem === true && 'Obrigatório'
                        }
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <ConditionalContainer show={showDescrAltoImpactoLocalField}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="descr_alto_impacto_local"
                      label="Comente qual o desafio da sua produção para auxiliarmos em sua viabilização"
                      onChange={handleChange}
                      required
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descr_alto_impacto_local
                      }
                      disabled={!isAdminRequest}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <Input
                    type="text"
                    name="address"
                    label="Nome do Espaço"
                    required
                    onChange={handleChange}
                    defaultValue={responseLocation?.address}
                    disabled={!isAdminRequest}
                  />
                </Wrap>

                <Wrap>
                  <DateFormMultiInput
                    label="Data da Filmagem"
                    dates={datasFilmagemInputs}
                    setDates={setDatasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={false}
                    dateKeyName="data_filmagem"
                    tooltip="Possível adicionar mais de uma data. Fundo azul indica campo aguardando aprovação."
                    isAdminRequest={isAdminRequest}
                    acceptPast
                    isRequired
                  />

                  <HourFormMultiInput
                    label="Hora da Filmagem (Início - Fim)"
                    hours={horasFilmagemInputs}
                    setHours={setHorasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={false}
                    hourBeginKeyName="inicio"
                    hourEndKeyName="fim"
                    tooltip="Incluir horário de montagem/desmontagem"
                    isAdminRequest={isAdminRequest}
                    isRequired
                  />
                </Wrap>

                <Wrap>
                  <Input
                    type="number"
                    name="tamanho_equipe_tecnica"
                    label="Tamanho da Equipe Técnica"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.tamanho_equipe_tecnica
                    }
                    disabled={!isAdminRequest}
                  />

                  <Input
                    type="number"
                    name="tamanho_do_elenco"
                    label="Tamanho do elenco"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.tamanho_do_elenco
                    }
                    disabled={!isAdminRequest}
                  />
                </Wrap>

                <Wrap>
                  <Textarea
                    type="text"
                    name="descricao_cena"
                    label="Descrição da Cena"
                    onChange={handleChange}
                    rows="3"
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.descricao_cena
                    }
                    disabled={!isAdminRequest}
                  />
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Você precisa isolar alguma área e/ou interferir no fluxo dos frequentadores?"
                      onClickTrue={handleIsolarLocalTrue}
                      onClickFalse={handleIsolarLocalFalse}
                      selected={isolarLocal}
                      required
                      isDisabled={!isAdminRequest}
                      error={errorsForm.isolarLocal === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={isolarLocal}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="fluxo_area"
                      label="Descrição do Local"
                      onChange={handleChange}
                      rows="2"
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default.fluxo_area
                      }
                      disabled={!isAdminRequest}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Haverá alguma intervenção de arte no local?"
                      onClickTrue={handleIntervencaoArteTrue}
                      onClickFalse={handleIntervencaoArteFalse}
                      selected={intervencaoArte}
                      required
                      isDisabled={!isAdminRequest}
                      error={
                        errorsForm.intervencaoArte === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={intervencaoArte}>
                  <Wrap>
                    <File
                      label="Relatório de Arte:"
                      attach={dataRelatorioArteFile}
                      textFile="Nenhum arquivo selecionado"
                      name="relatorio_arte_file"
                      inputRef={relatorioArteRef}
                      onChange={handleFileChange}
                      onClick={handleRelatorioArteFile}
                      required
                      error={
                        errorsForm.relatorioArteFile === true && 'Obrigatório'
                      }
                      link={fileArte?.length > 0 && fileArte[0].url}
                      isDisabled={!isAdminRequest}
                    />
                  </Wrap>

                  <Wrap>
                    <Textarea
                      type="text"
                      name="desc_intervencao_arte"
                      label="Descreva a(s) intervenção(ões)"
                      onChange={handleChange}
                      rows="2"
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default.desc_intervencao_arte
                      }
                      disabled={!isAdminRequest}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_equipamento_filmagem"
                      label="Qual a sua estrutura e equipamentos de filmagem:"
                      placeholder="Selecione"
                      options={equipamentosSelectList}
                      style={selectCustomStyles}
                      onChange={handleMultiSelectEquipamentos}
                      isMulti
                      required
                      isDisabled={!isAdminRequest}
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={showOutroEquipamentoField}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="outro_equipamento"
                        label="Outro Equipamento"
                        required
                        onChange={handleChange}
                        defaultValue={
                          responseLocation?.locacao_default?.outro_equipamento
                        }
                        disabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                  </ConditionalContainer>
                </Wrap>

                <ConditionalContainer show={showDescrEquipamentoFilmagemField}>
                  <Wrap>
                    <Textarea
                      label="Descreva a(s) extensão(ões)"
                      required
                      name="descricoes_equipamento_filmagem"
                      onChange={handleChange}
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descricoes_equipamento_filmagem
                      }
                      disabled={!isAdminRequest}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap style={{ alignItems: 'flex-end' }}>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Haverá gerador?"
                      onClickTrue={handleGeradorTrue}
                      onClickFalse={handleGeradorFalse}
                      selected={gerador}
                      required
                      isDisabled={!isAdminRequest}
                      error={errorsForm.gerador === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={gerador}>
                    <LimiterInputWidth w25>
                      <ChoiceButtonLocacao
                        label="Blimpado/Silencioso ou Não-Blimpado?"
                        onClickTrue={handleBlimpadorTrue}
                        onClickFalse={handleBlimpadorFalse}
                        selected={blimpado}
                        required
                        isDisabled={!isAdminRequest}
                        error={errorsForm.blimpado === true && 'Obrigatório'}
                        yesLabelValue="Blimpado"
                        noLabelValue="Não-Blimpado"
                      />
                    </LimiterInputWidth>
                  </ConditionalContainer>
                </Wrap>

                <ConditionalContainer show={gerador}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Gerador portátil ou ficará sobre um veículo?"
                        onClickTrue={handleGeradorPortatilTrue}
                        onClickFalse={handleGeradorPortatilFalse}
                        selected={geradorPortatil}
                        required
                        isDisabled={!isAdminRequest}
                        error={
                          errorsForm.geradorPortatil === true && 'Obrigatório'
                        }
                        yesLabelValue="Gerador portátil"
                        noLabelValue="Sobre um veículo"
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Precisará montar Base de Apoio no local?"
                      onClickTrue={handleBaseLocalTrue}
                      onClickFalse={handleBaseLocalFalse}
                      selected={baseLocal}
                      required
                      isDisabled={!isAdminRequest}
                      error={errorsForm.baseLocal === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={baseLocal}>
                  <Wrap style={{ marginBottom: 0 }}>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_finalidade_base_apoio"
                        label="Selecione as Finalidades"
                        placeholder="Selecione"
                        options={finalidadeSelectList}
                        style={selectCustomStyles}
                        required
                        onChange={handleMultiSelectFinalidades}
                        isMulti
                        isDisabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                    <ConditionalContainer show={showOutroFinalidadeField}>
                      <Input
                        type="text"
                        name="outro_finalidade"
                        label="Outra Finalidade"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.outro_finalidade
                        }
                        disabled={!isAdminRequest}
                      />
                    </ConditionalContainer>
                  </Wrap>

                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="local_base_apoio"
                        label="Descreva local da base de apoio"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.local_base_apoio
                        }
                        disabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>

                    <LimiterInputWidth w25 style={{ marginRight: 0 }}>
                      <Input
                        type="number"
                        step="0.01"
                        name="dimensao_base_apoio"
                        label="Descreva a dimensão estimada da área"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.dimensao_base_apoio
                        }
                        disabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>

                    <BoxHeader style={{ justifyContent: 'center', width: 50 }}>
                      <span className="boxText" style={{ color: '#828282' }}>
                        ou
                      </span>
                    </BoxHeader>

                    <LimiterInputWidth w25>
                      <Input
                        type="number"
                        name="quantidade_barracas"
                        label="Descreva a quantidade de barracas a serem montadas"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.quantidade_barracas
                        }
                        disabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Captação de som direto?"
                      onClickTrue={handleCaptacaoSomDiretoTrue}
                      onClickFalse={handleCaptacaoSomDiretoFalse}
                      selected={captacaoSomDireto}
                      required
                      isDisabled={!isAdminRequest}
                      error={
                        errorsForm.captacaoSomDireto === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá som na filmagem?"
                      onClickTrue={handleSomFilmagemTrue}
                      onClickFalse={handleSomFilmagemFalse}
                      selected={somFilmagem}
                      required
                      error={errorsForm?.somFilmagem === true && 'Obrigatório'}
                      isDisabled={!isAdminRequest}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={somFilmagem}>
                  <Wrap>
                    <LimiterInputWidth w75>
                      <Select
                        name="ld_som_filmagem"
                        label="Sons de Filmagem"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        required
                        options={somFilmagemSelectList}
                        onChange={handleMultiSelectSomFilmagem}
                        isMulti
                        isDisabled={!isAdminRequest}
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <ConditionalContainer show={showOutroSomFilmagemField}>
                    <Wrap>
                      <Input
                        type="text"
                        name="outro_som_filmagem"
                        label="Outro Som de Filmagem"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default?.outro_som_filmagem
                        }
                        disabled={!isAdminRequest}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  <ConditionalContainer show={showDescrSomFilmagemField}>
                    <Wrap>
                      <Textarea
                        label="Descreva a(s) característica(s)"
                        required
                        name="descricoes_som_filmagem"
                        onChange={handleChange}
                        rows="3"
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default
                            ?.descricoes_som_filmagem
                        }
                        disabled={!isAdminRequest}
                      />
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Efeitos Especiais"
                      onClickTrue={handleEfeitosEspeciaisTrue}
                      onClickFalse={handleEfeitosEspeciaisFalse}
                      selected={efeitosEspeciais}
                      required
                      isDisabled={!isAdminRequest}
                      error={
                        errorsForm.efeitosEspeciais === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>

                  <ConditionalContainer show={efeitosEspeciais}>
                    <Select
                      name="ld_efeitos_especiais_uuid"
                      label="Efeitos Especiais"
                      placeholder="Selecione"
                      style={selectCustomStyles}
                      required
                      options={efeitoEspecialSelectList}
                      onChange={value => {
                        handleSelectChange('ld_efeitos_especiais_uuid', value);
                      }}
                      isDisabled={!isAdminRequest}
                    />
                  </ConditionalContainer>
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá animais de cena?"
                      onClickTrue={handleHaveraAnimaisTrue}
                      onClickFalse={handleHaveraAnimaisFalse}
                      selected={haveraAnimais}
                      required
                      isDisabled={!isAdminRequest}
                      error={errorsForm.haveraAnimais === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={haveraAnimais}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="descricao_animais"
                      label="Descreva os animais"
                      onChange={handleChange}
                      rows="2"
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default?.animais_em_cena
                      }
                      disabled={!isAdminRequest}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <Input
                    type="text"
                    name="especificidades"
                    label=" Descreva especificidades não contempladas nas perguntas acima"
                    onChange={handleChange}
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.especificidades
                    }
                    disabled={!isAdminRequest}
                  />
                </Wrap>

                <Wrap style={{ flexDirection: 'column' }}>
                  {dadoState?.viewData && reservasVagas ? (
                    <>
                      <LimiterInputWidth w50>
                        <Select
                          name="reservas_vagas_locacao"
                          label="Reservas de Vagas"
                          placeholder="Selecione"
                          options={responseLocation?.locacao_via_externa?.map(
                            ({
                              uuid,
                              address,
                              number,
                              neighborhood,
                              endpoint,
                            }) => ({
                              label: `${address}, ${number}, ${neighborhood}`,
                              value: { uuid, endpoint },
                            }),
                          )}
                          style={selectCustomStyles}
                          onChange={value => {
                            handleSelectChange('reservas_vagas_locacao', value);
                          }}
                        />
                      </LimiterInputWidth>

                      {formData?.reservas_vagas_locacao && (
                        <Wrap>
                          <FormChoiceButton
                            nomeProjeto={dadoState?.nome_projeto}
                            editData={{
                              is_admin: isAdminRequest,
                              uuid: formData?.reservas_vagas_locacao?.uuid,
                              endpoint: 'reservas-vagas-vinculado',
                            }}
                          />
                        </Wrap>
                      )}
                    </>
                  ) : (
                    <ChoiceButtonLocacao
                      label="Necessita de reserva de vagas em via próxima?"
                      onClickTrue={handleReservasVagasTrue}
                      onClickFalse={handleReservasVagasFalse}
                      selected={reservasVagas}
                      required
                      isDisabled
                      error={errorsForm.reservasVagas === true && 'Obrigatório'}
                    />
                  )}
                </Wrap>
              </WhiteBox>

              <Chat
                uuid={responseLocation?.locacao_default?.uuid}
                chatKeyFilter="locacao_default"
                locacaoNameView={responseLocation?.name_view}
              />

              <Button
                type="submit"
                btType="#26A2B1"
                label="Enviar"
                full
                width="140px"
                loading={loading}
                disable={loading}
                style={{ position: 'relative', bottom: '35px' }}
              />
            </Form>
          </PageContent>
        </PageContainer>
      </>
    );
  }

  return (
    <>
      <Header>
        <LogoIcon />
        {!isAdminRequest && <NavBarHeader />}
      </Header>

      <BannerHeader>
        <BannerContent>
          <TextBanner>
            <h1>Filmagens em Espaços de Cultura</h1>
            {!isAdminRequest && (
              <span>
                Home | Obras | {dadoState?.nome_projeto} | Locações | Filmagens
                em Espaços de Cultura
              </span>
            )}
          </TextBanner>
        </BannerContent>
      </BannerHeader>

      {renderLocacao()}

      <PageFooter>
       <img
          src={clientResources.images.system.spcineLogo}
          alt={clientResources.images.system.altLogo}
        />
        <img
          src={clientResources.images.system.culturaSpLogo}
          alt={clientResources.images.system.altCultura}
        />
      </PageFooter>

      <ModalPorteFilmagem
        openModal={openModalPorteFilmagem}
        closeModal={() => setOpenModalPorteFilmagem(false)}
      />
    </>
  );
};

export default EspacosDeCulturaEdit;
